import { __decorate } from "tslib";
import { CommonModule } from '@angular/common';
import { provideRootRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let HealthInsurancesFrontendAdminFeature = /*#__PURE__*/(() => {
  let HealthInsurancesFrontendAdminFeature = class HealthInsurancesFrontendAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/health-insurances/frontend-admin","featureId":"common-health-insurances"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        adminToolbar: [{
          routerLink: 'health-insurances',
          label: 'Krankenversicherungen',
          icon: 'house-medical-flag',
          priority: 5
        }]
      });
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵHealthInsurancesFrontendAdminFeature_BaseFactory;
        return function HealthInsurancesFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵHealthInsurancesFrontendAdminFeature_BaseFactory || (ɵHealthInsurancesFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(HealthInsurancesFrontendAdminFeature)))(__ngFactoryType__ || HealthInsurancesFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HealthInsurancesFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'health-insurances',
          loadChildren: () => import('./manager/health-insurances-manager.module').then(m => m.HealthInsurancesManagerModule)
        }])
        // provideFeatureAddonRoutes([])
        ],
        imports: [CommonModule]
      });
    }
  };
  HealthInsurancesFrontendAdminFeature = __decorate([ClassName("HealthInsurancesFrontendAdminFeature")], HealthInsurancesFrontendAdminFeature);
  return HealthInsurancesFrontendAdminFeature;
})();
export { HealthInsurancesFrontendAdminFeature };